import ImageFive from '../images/ImageFive.png'
import ImageEight from '../images/ImageEight.png'
import ImageThirteen from '../images/ImageThirteen.png'
import ImageFourteen from '../images/ImageFourteen.png'

export const SliderData = [
    {
        title: 'Móveis sob medida',
        price: '',
        path: '/contato',
        label: 'Contato',
        image: ImageFive,
        alt: 'House'
    },
    {
        title: 'Planejamento Profissional',
        price: '',
        path: '/contato',
        label: 'Contato',
        image: ImageEight,
        alt: 'House'
    },
    {
        title: 'Consultoria',
        price: '',
        path: '/contato',
        label: 'Contato',
        image: ImageThirteen,
        alt: 'House'
    },
    {
        title: 'Profissionais qualificados',
        price: '',
        path: '/contato',
        label: 'Contato',
        image: ImageFourteen,
        alt: 'House'
    },
]